import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

const WhatsButton = styled.a`
  position: fixed !important;
  inset: auto auto clamp(1rem, 2vw, 1.75rem) clamp(1rem, 2vw, 1.75rem) !important;
  z-index: 9999;

  width: 82px;
  height: 82px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  text-decoration: none;
  color: white;
  background: linear-gradient(135deg, #25d366, #1ebe5d);
  overflow: hidden;
  box-shadow:
    0 18px 45px rgba(37, 211, 102, 0.45),
    0 0 30px rgba(37, 211, 102, 0.28);

  font-size: 3rem;
  line-height: 1;
  transform: translateZ(0);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease;
  animation: pulseWhatsapp 2s infinite;

  &:hover {
    transform: scale(1.08) translateY(-3px);
    box-shadow:
      0 25px 60px rgba(37, 211, 102, 0.55),
      0 0 45px rgba(37, 211, 102, 0.4);
  }

  & svg {
    width: 1em !important;
    height: 1em !important;
    flex: 0 0 auto;
    display: block;
    pointer-events: none;
  }

  @keyframes pulseWhatsapp {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.06);
    }

    100% {
      transform: scale(1);
    }
  }
`;

const WhatsAppFloat = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    createPortal(
      <WhatsButton
        href="https://wa.me/593999999999"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </WhatsButton>,
      document.body
    )
  );
};

export default WhatsAppFloat;